module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.typeArr[0] === 'primary') ? _c('a', {
    staticClass: "ssui-btn",
    class: _vm.classes,
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.disabled ? _vm.$emit('btn-click-disabled') : _vm.$emit('btn-click')
      }
    }
  }, [_c('loading-icon', {
    staticClass: "btn-loading",
    attrs: {
      "loading": _vm.loading,
      "loading-finished": _vm.loadingFinished
    }
  }), _vm._v(" "), _vm._t("default", [_vm._v(_vm._s(_vm.text))])], 2) : (_vm.typeArr[0] === 'bottom') ? _c('div', {
    staticClass: "ssui-btn",
    class: _vm.classes
  }, [(_vm.typeArr[1] === 'layout1') ? _c('div', [(_vm.hasLeft) ? _c('div', {
    staticClass: "ssui-btn-bottom__left"
  }, [_vm._t("button-left")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ssui-btn-bottom__right"
  }, [_vm._t("button-tips"), _vm._v(" "), _c('a', {
    staticClass: "ssui-btn-bottom__btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.disabled ? _vm.$emit('btn-click-disabled') : _vm.$emit('btn-click')
      }
    }
  }, [_c('div', {
    staticClass: "ssui-btn-bottom__main"
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.text))])], 2), _vm._v(" "), (_vm.subText) ? _c('div', {
    staticClass: "ssui-btn-bottom__sub"
  }, [_vm._v(_vm._s(_vm.subText))]) : _vm._e()])], 2)]) : (_vm.typeArr[1] === 'layout2') ? _c('div', [(_vm.hasLeft) ? _c('a', {
    staticClass: "ssui-btn-bottom__left",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.disabledLeft ? _vm.$emit('btn-click-left-disabled') : _vm.$emit('btn-click-left')
      }
    }
  }, [_vm._v(_vm._s(_vm.textLeft))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "ssui-btn-bottom__right",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.disabledRight ? _vm.$emit('btn-click-right-disabled') : _vm.$emit('btn-click-right')
      }
    }
  }, [_vm._v(_vm._s(_vm.textRight))])]) : (_vm.typeArr[1] === 'layout3') ? [(_vm.hasLeft) ? _c('a', {
    staticClass: "ssui-btn-bottom__left",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.disabledLeft ? _vm.$emit('btn-click-left-disabled') : _vm.$emit('btn-click-left')
      }
    }
  }, [_vm._v(_vm._s(_vm.textLeft))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "ssui-btn-bottom__right",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.disabledRight ? _vm.$emit('btn-click-right-disabled') : _vm.$emit('btn-click-right')
      }
    }
  }, [_vm._v(_vm._s(_vm.textRight))])] : _vm._e()], 2) : (_vm.typeArr[0] === 'small') ? _c('a', {
    staticClass: "ssui-btn",
    class: _vm.classes,
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.disabled ? _vm.$emit('btn-click-disabled') : _vm.$emit('btn-click')
      }
    }
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.text))])], 2) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0fde5dcc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fde5dcc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@finance/ssvue/src/components/x-button/index.vue
// module id = 254
// module chunks = 8